export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export function scoreBandClass(score) {
  if (score >= 95) return "score-band-95";
  if (score >= 85) return "score-band-85";
  if (score >= 75) return "score-band-75";
  if (score >= 60) return "score-band-60";
  return "score-band-0";
}

export function scoreBandLabel(score) {
  if (score >= 95) return "Outstanding";
  if (score >= 85) return "Exceeds Expectations";
  if (score >= 75) return "Meets Expectations";
  if (score >= 60) return "Needs Improvement";
  return "Unsatisfactory";
}

export function formatCurrency(value, currency = "USD") {
  if (value == null) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}
